<template>
  <div class="form-group" :class="{'input-box': showInputBox}">
    <i
      v-if="addEmailNotification"
      class="glyphicon glyphicon-envelope"
      v-tooltip="'Email might be generated'"
      title="Email might be generated"
    >
    </i>

    <span class="form-group">
      <label :class="{ 'text-danger': hasErrors(getFieldName) }"> {{ label }} </label>
      <comments v-if="addComment" :field-name="getCommentfieldName" :model-name="modelName"></comments>
    </span>

    <div :class="{ 'input-group': this.$slots['group-addon-after'] }">
      <select
        class="form-control"
        v-model.lazy="inputVal"
        :name="getFieldName"
        :data-vv-as="label"
        :disabled="isReadOnly || disabled"
        v-bind="$attrs"
        v-validate.immediate="vvalidate"
      >
        <slot name="options"></slot>
        <option v-for="(option, index) in options" :value="option.value" :key="index">
          {{ option.display }}
        </option>
      </select>
      <slot name="group-addon-after"></slot>
    </div>

    <span v-show="errors.has(getFieldName)" class="text-danger">{{ errors.first(getFieldName) }}</span>

    <div v-show="hasErrors(getFieldName)">
      <span
        v-for="(error, index) in errorsFor(getFieldName)"
        class="text-danger"
        :key="`error_${getFieldName}_${index}`"
      >
        {{ error }}
      </span>
    </div>
  </div>
</template>

<script>
import CustomInputMixin from './CustomInputMixin'

export default {
  name: 'SelectInput',
  mixins: [CustomInputMixin],
  props: {
    options: Array,
  },
  computed: {
    isMultiple: function () {
      return 'multiple' in this.$attrs
    },
    inputVal: {
      get() {
        return this.isMultiple
          ? this.getFieldValue(this.getFieldName, this.modelName) || []
          : this.getFieldValue(this.getFieldName, this.modelName)
      },
      set(val) {
        let payload = {
          fieldName: this.getFieldName,
          value: val,
          modelName: this.modelName,
        }

        this.setFieldValue(payload)
        this.$emit('on-change', payload)
      },
    },
  },
}
</script>

<style scoped>
i {
  margin-right: 0.5em;
}
</style>
